<template>
  <w-flex wrap>
    <div class="xs12 headline text-left pl7">
      {{ baseStationResource.id != "" ? "Edit" : "Add" }} Base Station
    </div>
  </w-flex>
  <w-flex wrap>
    <div class="xs12 pa1">
      <div v-if="loading">
        <w-progress class="ma1" circle :model-value="undefined" size="6em"></w-progress>
      </div>
      <div v-else>
        <div v-if="baseStationResource.imei === ''">
          <div v-if="errorMessage == null && this.$route.query.imei !== undefined">
            <w-flex wrap>
              <div class="xs12 pa5">
                <w-icon class="pa5" size="5em" bg-color="" color="green">
                  mdi mdi-magnify
                </w-icon>
              </div>
              <div class="title3 xs12 text-centre pa5">
                Ricerca Base Station.
              </div>
            </w-flex>
          </div>
          <div v-else>
            <w-form @submit.prevent="valid ? isNewDevice($event) : null" v-model="valid">
              <w-flex wrap>
                <div class="xs12 md6 pa1">
                  <w-input name="imei" :validators="[validators.required]">
                    IMEI</w-input>
                </div>
                <div class="xs12 md6 pa1">
                  <w-button bg-color="primary" type="submit" @keyup.enter="isNewDevice($event)">
                    CERCA
                  </w-button>
                </div>
              </w-flex>
            </w-form>
          </div>
        </div>
        <div v-else>
          <div v-if="!baseStationAdded">
            <w-form @submit.prevent="valid ? addBaseStation() : null" v-model="valid">
              <!-- v-model="valid" no-keyup-validation no-blur-validation -->
              <w-flex wrap>
                <div class="xs12 pa1">
                  <w-input name="nickname" v-model="baseStationResource.nickname" :validators="[
                    validators.required
                  ]">
                    Nickname</w-input>
                </div>
                <div class="xs6 pa1">
                  <w-input type="number" name="latitude" v-model="baseStationResource.latitude"
                    :validators="[validators.notNull, validators.notZero, validators.latitude]"
                    inner-icon-right="mdi mdi-magnify" :loading="loadingIcon" @click:inner-icon-right="getLocation()">
                    Latitude</w-input>
                </div>
                <div class="xs6 pa1">
                  <w-input type="number" name="longitude" v-model="baseStationResource.longitude"
                    :validators="[validators.notNull, validators.notZero, validators.longitude]"
                    inner-icon-right="mdi mdi-magnify" :loading="loadingIcon" @click:inner-icon-right="getLocation()">
                    Longitude</w-input>
                </div>
                <div class="xs12 pa1">
                  <w-input no-autogrow name="address" rows="3" v-model="baseStationResource.address"
                    :validators="[validators.required]">
                    Address</w-input>
                </div>
                <!--  LABELS COMPONENT  ADMIN Only -->

                <AddLabels v-if="store.currentUser.roles.includes('ADMIN')" :labelsList="labels"
                  @removeLabel="removeLabel" @addLabel="addLabel" />
                <div class="xs6">
                  <w-button class="my1 mr2" bg-color="primary" type="reset"
                    @click="resetBaseStationResource(this.$router)">
                    ANNULLA
                  </w-button>
                </div>
                <div class="xs6">
                  <w-button bg-color="primary" type="submit">
                    <!-- :disabled="valid !== true" -->
                    INSERISCI
                  </w-button>
                </div>
              </w-flex>
            </w-form>
          </div>
          <div v-else>
            <w-flex wrap>
              <div class="xs12 pa5">
                <w-icon class="pa5" size="5em" bg-color="" color="green">
                  mdi mdi-check-outline
                </w-icon>
              </div>
              <br />
              <div class="title3 xs12 text-centre pa5">
                Base Station inserita correttamente. Puoi trovarla nella sezione
                <router-link :to="'/things/All'">Things</router-link>.
              </div>
              <br />
              <div class="xs12 pa5">
                <w-button bg-color="primary" type="reset" @click="
                  (baseStationAdded = false),
                  (errorMessage = null),
                  resetBaseStationResource(this.$router)
                  ">
                  <!-- valid = null, -->
                  OK
                </w-button>
              </div>
              <div class="xs12 pa1">
                <w-flex wrap class="">
                  <div class="mxa pa1 flex-center">
                    <div class="pa1 headline text-center">
                      Stato del MountPoint: {{ baseStationResource.mountpoint }}
                    </div>
                    <div class=" pa1">
                      <div class="circular-square" :class="running ? 'bg-green' : 'bg-red'"></div>
                    </div>
                  </div>
                  <div v-if="running" class="xs12 pa2">
                    <w-card content-class="pa1 w-flex" title="MountPoint" title-class="primary--bg" text-left>
                      <w-flex wrap>
                        <div class="xs12 pa2 scroll-container">
                          <w-flex wrap>
                            <div v-for="[key, value] of Object.entries(
                              runningMountPoint
                            )" :key="value" class="xs12">
                              <w-flex wrap fill-width>
                                <div class="xs6 text-bold text-right pa1 word-break">
                                  {{ key }}
                                </div>
                                <div class="xs6 text-left pa1 word-break">
                                  {{ value }}
                                </div>
                              </w-flex>
                            </div>
                          </w-flex>
                        </div>
                      </w-flex>
                    </w-card>
                  </div>
                </w-flex>
              </div>
            </w-flex>
          </div>
        </div>
        <div class="xs12">
          <w-alert error v-if="errorMessage != null">{{
            errorMessage
          }}</w-alert>
        </div>
      </div>
    </div>
  </w-flex>
</template>

<script>
import { http } from "@/http";
import { ref, onBeforeMount, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";
import "@mdi/font/css/materialdesignicons.min.css";
import LabelService from "@/modules/label-group/LabelService";
import AddLabels from "../components/AddLabels.vue";
import errorManager from "@/modules/errors/error-services/error-manager";
import { store } from "@/utils/store";
import { ErrorMessage } from "@/models/ErrorMessage";

export default {
  name: "AddBaseStationView",
  components: { AddLabels },
  setup: () => {
    //LABELS separatamenete per ora
    const labelRef = ref()
    const labels = ref([]);
    function removeLabel(e) {
      console.log(e);
      labels.value = labels.value.filter((i) => i != e);
    }
    function addLabel(e) {
      labels.value.push(e);
    }
    const route = useRoute();
    const imeiToSearch = ref(null);
    //TODO this could be an object
    const baseStationResource = ref({
      nickname: "",
      latitude: "",
      longitude: "",
      address: "",
      imei: "",
      id: "",
      mountpoint: "",
      ntripUsername: "",
      ntripPassword: "",
      ntripUrl: "",
    });
    const running = ref(false);
    const runningMountPoint = ref({});
    const errorMessage = ref(null);
    const baseStationAdded = ref(false);
    const valid = ref(null);
    const loading = ref(false);
    const loadingIcon = ref(false);
    const polling = ref(undefined);
    onBeforeMount(async () => {
      if (route.query.imei !== undefined) {
        imeiToSearch.value = route.query.imei;
        await isNewDevice(null);
      }
    });
    onBeforeUnmount(() => {
      clearInterval(polling.value);
    });
    function getLocation() {
      loadingIcon.value = true;
      return new Promise((resolve, reject) => {
        // if(navigator.geolocation === {}) {
        //   console.log("qua")
        //   window.alert("Geolocation is not available.");
        //   reject(new Error('Geolocation is not available.'));
        // }
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            baseStationResource.value.latitude = pos.coords.latitude;
            baseStationResource.value.longitude = pos.coords.longitude;
            loadingIcon.value = false;
            resolve(pos);
          },
          (err) => {
            window.alert(
              "Geolocalizzazione non disponibile. Controllare privacy del browser."
            );
            loadingIcon.value = false;
            reject(err);
          }
        );
      });
    }
    function resetBaseStationResource(router) {
      baseStationResource.value = {
        nickname: "",
        latitude: "",
        longitude: "",
        address: "",
        imei: "",
        id: "",
        mountpoint: "",
        ntripUsername: "",
        ntripPassword: "",
        ntripUrl: "",
      };
      labels.value=[];
      baseStationAdded.value = false;
      errorMessage.value = null;
      //TOCHECK accheserve??
      router.push("/addBaseStation");
    }
    async function isNewDevice(event) {
      loading.value = true;
      if (event !== null && event != "") {
        const data = Object.fromEntries(new FormData(event.target));
        imeiToSearch.value = data.imei;
      }
      if (imeiToSearch.value !== null) {
        http
          .get("/things/isNewDevice/" + imeiToSearch.value)
          .then((apiResponse) => {
            const { data } = apiResponse;
            if (data.id != null) {
              baseStationResource.value.imei = imeiToSearch.value;
              baseStationResource.value.address = data.address;
              baseStationResource.value.latitude = data.coordinates[0];
              baseStationResource.value.longitude = data.coordinates[1];
              baseStationResource.value.nickname = data.nickname;
              baseStationResource.value.id = data.id;
              baseStationResource.value.mountpoint = data.mountpoint;
              baseStationResource.value.ntripUsername = data.ntripUsername;
              baseStationResource.value.ntripPassword = data.ntripPassword;
              baseStationResource.value.ntripUrl = data.ntripUrl;
            } else {
              baseStationResource.value.imei = imeiToSearch.value;
            }

            LabelService.getLabelsByImei(imeiToSearch.value).then(({ data }) => {
              console.log(data);
              labels.value = labels.value.concat(data.accessLabels);
              console.log(labels);
            }).catch((err) => (errorManager.manage(err, errorManager.caseNotFound(() => console.log("no labels found for " + imeiToSearch.value)))))
              .finally(() => {
                errorMessage.value = null;
                loading.value = false;
                valid.value = null;
              });
          })
          .catch((error) => {
            loading.value = false;
            errorMessage.value =
              error.response !== undefined
                ? error.response.data
                : error.message;
            return errorManager.manage(error, errorManager.caseNotFound(
              () => errorManager.deafaultReject(new ErrorMessage(error, "Imei sconoscuto inserito", 404))),
              errorManager.case("BadRequest",
                () => errorManager.deafaultReject(new ErrorMessage(error, "Imei non corretto inserito", 400))))
          });
        //loads labelsf
        //TODO manage loading.value = false;
      } else {
        errorMessage.value = "Inserire IMEI";
        loading.value = false;
      }
    }
    async function addBaseStation() {
      loading.value = true;
      //TODO manage double request when store is added for page
      //
      await updateLabels().then(() => {
        errorMessage.value = null;
        http
          .post(
            "/things/newBaseStation",
            {
              coordinates:
                baseStationResource.value.latitude +
                "," +
                baseStationResource.value.longitude,
              nickname: baseStationResource.value.nickname,
              address: baseStationResource.value.address,
              imei: baseStationResource.value.imei,
              id: baseStationResource.value.id,
              mountpoint: baseStationResource.value.mountpoint,
              ntripUsername: baseStationResource.value.ntripUsername,
              ntripPassword: baseStationResource.value.ntripPassword,
              ntripUrl: baseStationResource.value.ntripUrl,
            }
          )
          .then((apiResponse) => {
            errorMessage.value = null;
            if (apiResponse.status === 200) {
              const { data } = apiResponse;
              baseStationResource.value.imei = imeiToSearch.value;
              baseStationResource.value.address = data.address;
              baseStationResource.value.latitude = data.coordinates[0];
              baseStationResource.value.longitude = data.coordinates[1];
              baseStationResource.value.nickname = data.nickname;
              baseStationResource.value.id = data.id;
              baseStationResource.value.mountpoint = data.mountpoint;
              baseStationResource.value.ntripUsername = data.ntripUsername;
              baseStationResource.value.ntripPassword = data.ntripPassword;
              baseStationResource.value.ntripUrl = data.ntripUrl;
              loading.value = false;
              baseStationAdded.value = true;
            }
          })
          .catch((error) => {
            loading.value = false;
            errorMessage.value =
              error.response !== undefined ? error.response.data : error.message;
          })
      }).catch((error) => {
        loading.value = false;
        errorMessage.value =
          error.response !== undefined ? error.response.data : error.message;
      });

      async function updateLabels() {
        if (store.currentUser.roles.includes('ADMIN')) {


          return LabelService.updateLabelsToImei(imeiToSearch.value, labels.value)
            .then(({ data }) => {
              console.log("resolve as ADMIN");

              labels.value = data.accessLabels;
              return Promise.resolve()
            })
            .catch((er) => {
              console.log(er);
              return Promise.reject(er)
            });
        } else {
          console.log("resolve as Installer");

          return Promise.resolve()
        }
      }
    }
    watch(baseStationAdded, () => {
      getMountPointStatus();
    });
    function getMountPointStatus() {
      if (baseStationAdded.value) {
        polling.value = setInterval(function () {
          http
            .post(
              "/mountpoints/states",
              {
                mountpoint: baseStationResource.value.mountpoint,
              }
            )
            .then((apiResponse) => {
              errorMessage.value = null;
              if (apiResponse.data !== "") {
                running.value = true;
                runningMountPoint.value = apiResponse.data;
              } else {
                running.value = false;
                runningMountPoint.value = {};
              }
            })
            .catch((error) => {
              running.value = false;
              errorMessage.value =
                error.response !== undefined
                  ? error.response.data
                  : error.message;
            });
        }, 4000);
      } else {
        clearInterval(polling.value);
      }
    }
    return {
      baseStationResource,
      running,
      runningMountPoint,
      baseStationAdded: baseStationAdded,
      opacity: 0.3,
      persistent: false,
      persistentNoAnimation: false,
      isNewDevice,
      addBaseStation,
      resetBaseStationResource,
      getLocation,
      getMountPointStatus,
      valid,
      validators: {
        notNull: (value) =>
          (value != null && value != undefined && (value instanceof String ? value.trim() != "" : value != "")) || "This field is required",
        notZero: (value) => (value != 0) || "A valid value is required",
        required: (value) => !!value || "This field is required",
        withoutSpaces: (value) => !/\s/g.test(value) || "Spaces not allowed",
        latitude: (value) => /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/.test(value) || "insert valid latitude",
        longitude: (value) => /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/.test(value) || "insert valid longitude"
      },

      errorMessage,
      loading,
      loadingIcon,
      //lables
      labels,
      addLabel,
      removeLabel,
      labelRef,
      store
    };
  },
};
</script>

<style scoped>
.circular-square {
  margin-left: auto;
  margin-right: auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-green {
  background-color: green;
}

.bg-red {
  background-color: red;
}

.scroll-container {
  height: 160px;
  overflow-y: scroll;
}

.word-break {
  word-wrap: break-word;
}
</style>
